export const isValidPartnerLogoOverride = (
  logoOverride?: string | null,
): boolean => {
  return Boolean(logoOverride && logoOverride.trim() !== "");
};
